import { useMemo } from 'react';
import CommonTable from '../../../common/CommonTable';

const ImpactedArea_LN = ({
    loading,
    tableData,
    currentTimestamp,
    headerDate,
    showThreatType = false
}) => {
    // Define legend colors
    const legendColors = useMemo(() => ({
        'High': "rgb(230, 45, 58)",
        'Medium': "rgb(243, 155, 58)",
        'Low': "rgb(243, 235, 18)",
        'NoRisk': "rgb(148, 203, 85)",
        "N/A": "rgb(222,222,223)",
        'All': '#f0f0f0',
    }), []);

    // Define columns configuration
    const columns = useMemo(() => {
        const baseColumns = [
            {
                key: 'SlNo',
                label: 'Sl No',
                sortable: false,
                align: 'center',
            },
            {
                key: 'Municipality',
                label: 'Municipality',
                sortable: true,
                align: 'left',
            },
            {
                key: 'PostAdmin',
                label: 'Post Admin',
                sortable: true,
                align: 'left',
            },
        ];

        // Conditionally add Suco column
        if (showThreatType) {
            baseColumns.push({
                key: 'Suco',
                label: 'Suco',
                sortable: true,
                align: 'left',
            });
        }

        // Add remaining columns
        baseColumns.push(
            {
                key: 'date_hr',
                label: 'Date/Time',
                sortable: true,
                align: 'left',
            }
        );

        // Conditionally add Threat Type column
        if (showThreatType) {
            baseColumns.push({
                key: 'threatType',
                label: 'Threat Type',
                sortable: true,
                align: 'left',
                render: (row) => (
                    <span style={{ fontWeight: 600, color: '#1e40af' }}>
                        {row.threatType || '-'}
                    </span>
                ),
            });
        }

        // Add Advisory column
        baseColumns.push({
            key: 'advisory',
            label: 'Advisory',
            sortable: false,
            align: 'left',
            render: (row, getColor) => {
                const advisoryColor = getColor(row.advisory);
                const isDark = (row.advisory || '').toLowerCase().includes('high') || 
                               (row.advisory || '').toLowerCase().includes('medium');
                
                return (
                    <span
                        style={{
                            backgroundColor: advisoryColor,
                            padding: '6px 12px',
                            borderRadius: '6px',
                            color: isDark ? 'white' : 'black',
                            fontWeight: 'bold',
                            fontSize: '12.5px',
                        }}
                    >
                        {row.advisory || 'N/A'}
                    </span>
                );
            },
        });

        return baseColumns;
    }, [showThreatType]);

    // Define searchable keys
    const searchableKeys = useMemo(() => {
        const keys = ['Municipality', 'PostAdmin', 'date_hr', 'advisory'];
        if (showThreatType) {
            keys.push('Suco', 'threatType');
        }
        return keys;
    }, [showThreatType]);

    // Filter options for risk levels
    const filterOptions = ['All', 'High', 'Medium', 'Low', 'NoRisk'];

    return (
        <CommonTable
            tableData={tableData}
            columns={columns}
            currentTimestamp={currentTimestamp}
            showFilter={true}
            filterOptions={filterOptions}
            legendColors={legendColors}
            searchableKeys={searchableKeys}
            tableName="Lightning_Threats"
            searchPlaceholder="Search by Municipality, Post Admin, Suco..."
            emptyMessage="No impact data found for the selected filter."
        />
        
    );
};

export default ImpactedArea_LN;